import { useMemo } from 'react';

import { ColorOptionButton } from './ColorOptionButton';
import { ColorOptionLink } from './ColorOptionLink';

export function ProductColorOptionValue({
  groupingProductsMapByColor,
  inventory,
  isLoading,
  isSelected,
  name,
  product,
  selectedOptions,
  setSelectedOptions,
  value,
  swatches,
  disableGroupHistory,
  enabledSoldOutColorSwatch,
  isSoldOut,
  soldOutQty,
  needsSelection,
  optionChanges,
  groupedBreadcrumbs,
}) {
  const isFromGrouping = product.grouping?.isTransformed;

  const newSelectedOptions = useMemo(() => {
    return selectedOptions
      ? {
          ...selectedOptions,
          [name]: value,
        }
      : null;
  }, [name, selectedOptions, value]);

  const swatch = useMemo(() => {
    if (!swatches) return null;
    return (
      swatches.find(
        ({ name: swatchName }) =>
          swatchName?.trim().toLowerCase() === value.toLowerCase()
      ) || null
    );
  }, [swatches, value]);

  return isFromGrouping ? (
    <ColorOptionLink
      groupingProductsMapByColor={groupingProductsMapByColor}
      isSelected={isSelected}
      newSelectedOptions={newSelectedOptions}
      swatch={swatch}
      value={value}
      disableGroupHistory={disableGroupHistory}
      enabledSoldOutColorSwatch={enabledSoldOutColorSwatch}
      soldOutQty={soldOutQty}
      needsSelection={needsSelection}
      optionChanges={optionChanges}
      groupedBreadcrumbs={groupedBreadcrumbs}
    />
  ) : (
    <ColorOptionButton
      inventory={inventory}
      isLoading={isLoading}
      isSelected={isSelected}
      newSelectedOptions={newSelectedOptions}
      product={product}
      setSelectedOptions={setSelectedOptions}
      swatch={swatch}
      value={value}
      enabledSoldOutColorSwatch={enabledSoldOutColorSwatch}
      isSoldOut={isSoldOut}
    />
  );
}

ProductColorOptionValue.displayName = 'ProductColorOptionValue';
